/* jslint browser: true */
import React, { Component } from 'react';

class Credits extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="lra-box">
                <div className="lra-box-header">Commandez vos programmes</div>
                <div className="lra-box-body">
                    <select
                        className="select"
                        style={{ margin: '20px auto', display: 'block' }}
                        value={this.props.credit}
                        onChange={this.props.onCreditChange}
                    >
                        {this.props.credits.map(item => {
                            return (
                                <option
                                    key={item.id_credit}
                                    value={item.id_credit}
                                >
                                    {item.libelle}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        );
    }
}

export default Credits;



// WEBPACK FOOTER //
// ./src/components/commande/Credits.js